import type { CSSProperties } from 'react';
import { speakJa } from './speech';

export interface SpeakButtonProps {
  /** Chuỗi tiếng Nhật cần đọc — null/rỗng thì không render nút (item không có dữ liệu đọc). */
  text: string | null;
  /** plain = chỉ icon; filled = nút tròn CTA đặc; outline = nút viền nhạt (danh sách từ). */
  variant?: 'plain' | 'filled' | 'outline';
  size?: number;
  label?: string;
}

const VolumeIcon = ({ size, color }: { size: number; color: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5 6 9H2v6h4l5 4z" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    <path d="M19 5a9 9 0 0 1 0 14" />
  </svg>
);

export function SpeakButton({ text, variant = 'filled', size = 44, label = 'Nghe phát âm' }: SpeakButtonProps) {
  if (!text) return null;
  const filled = variant === 'filled';
  const plain = variant === 'plain';

  const style: CSSProperties = {
    width: size,
    height: size,
    flexShrink: 0,
    borderRadius: filled ? '50%' : 'var(--radius-control)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: plain ? 'transparent' : filled ? 'var(--cta-default)' : 'var(--surface-card)',
    border: plain || filled ? 'none' : '1.5px solid var(--border-default)',
    boxShadow: filled ? 'var(--shadow-card)' : 'none',
  };

  return (
    <button
      type="button"
      aria-label={label}
      onClick={(e) => {
        e.stopPropagation();
        speakJa(text);
      }}
      style={style}
    >
      <VolumeIcon size={Math.round(size * (plain ? 0.58 : 0.45))} color={filled ? '#fff' : 'var(--cta-default)'} />
    </button>
  );
}
